import { CloseIcon } from "@/components/Icons"
import "@/components/styles/model.css";

export default function ViewTemplate({setViewType, template}) {
    return (
        <div className="model-opener">
            <div className="model-container view-template">
                <div className="model-header">
                    <div className="model-header-close">
                        <button onClick={()=>{setViewType("TEMPLATE_LIST")}}>
                            <CloseIcon />
                        </button>
                    </div>
                </div>
                <div className="view-template__container">
                    <div dangerouslySetInnerHTML={{__html: template.html_content}} />
                </div>
            </div>
        </div>
    )
}